/** Proposed display fragment. Supplied copy/spans only; no extraction, scoring or source inference. */
import type { ShopifyResultQuote } from '@testfeed/shopify-contracts'
import { ServerResultSource, ServerResultSourceLink } from './ServerResultSource'
import './response-phrases.css'

type Answer = Extract<ShopifyResultQuote, { citationUnit: 'answer' }>
export function ServerEvidencePassage({
  title,
  explanation,
  answer,
}: {
  title: string
  explanation: string
  answer: Answer
}) {
  const exchange = answer.originalExchange
  if (!exchange) throw new Error('Evidence passage requires its saved conversation source.')
  return (
    <ServerResultSource exchange={exchange}>
      <s-stack direction="block" gap="base">
        <s-heading>{title}</s-heading>
        <s-text color="subdued">{answer.source}</s-text>
        <p className="response-phrase-quote">
          {answer.segments.map((segment, index) => (
            <PassageSegment key={index} segment={segment} />
          ))}
        </p>
        <s-paragraph color="subdued">{explanation}</s-paragraph>
        <ServerResultSourceLink answerId={answer.id}>{exchange.sourceLinkLabel}</ServerResultSourceLink>
      </s-stack>
    </ServerResultSource>
  )
}

function PassageSegment({ segment }: { segment: Answer['segments'][number] }) {
  if (!segment.highlighted) return <>{segment.text}</>
  if (!segment.sourceTarget) throw new Error('Highlighted evidence requires its exact source target.')
  return (
    <ServerResultSourceLink answerId={segment.sourceTarget.answerId} segments={segment.sourceTarget.segments}>
      <mark>{segment.text}</mark>
    </ServerResultSourceLink>
  )
}
